<template>
  <div class="home">
    <div class="head-title">已成交客户</div>
    <div class="">
      <div class="">
        <div class="tianjia">
          <div class="nar">
            <div class="nar_r">
              <el-input clearable placeholder="请输入关键词搜索" style="width: 22.0rem; margin-right: 1.0rem"
                prefix-icon="el-icon-search" v-model="userSearch" @change="headlgetAgentAccounts()">
              </el-input>
              <el-button type="primary" @click="headlgetAgentAccounts()">搜索</el-button>
            </div>
          </div>
          <el-table :data="tableData.data" border style="width: 100%; text-aligh: center">
            <el-table-column prop="account" label="账号" width="120"></el-table-column>
            <el-table-column prop="phone" label="手机号" width="120"></el-table-column>
            <el-table-column prop="province" label="省"></el-table-column>
            <el-table-column prop="city" label="城市"></el-table-column>
            <el-table-column prop="address" label="详细地址" show-overflow-tooltip=""></el-table-column>
            <el-table-column prop="enterpriseName" label="企业名称" show-overflow-tooltip=""></el-table-column>
            <el-table-column prop="if_end" label="是否过期">
              <template slot-scope="scope">
                <div :class="{
                  danger: scope.row.if_end === '已过期',
                }">
                  {{ scope.row.if_end }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="addtime" label="注册时间" width="170">
            </el-table-column>
            <el-table-column prop="past_time" label="过期时间" width="170">
            </el-table-column>
            <el-table-column prop="priveName" label="用户权限" width="100" show-overflow-tooltip=""></el-table-column>
            <el-table-column prop="enterprisePhoto" label="营业执照">
              <template slot-scope="scope">
                <img :src="`${scope.row.enterprisePhoto}`" min-width="70" height="70" />
              </template>
            </el-table-column>
            <el-table-column prop="enterpriseScale" label="企业规模"></el-table-column>
            <el-table-column label="操作" fixed="right" width="240">
              <template slot-scope="scope">
                <el-button type="text" size="mini" @click="
                  (onSubmit = true), fp(scope.row.id, scope.row.priveName)
                  ">权限调整</el-button>
                <el-button type="text" @click="skip(scope.row)" size="mini">登录企业后台</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="paging">
            <pagination :total="tableData.total" :page.sync="listQuery.page" :limit.sync="listQuery.limit"
              :page-sizes="[10, 20, 50, 100]" @pagination="headlgetAgentAccounts" />
          </div>
        </div>
        <el-dialog title="开通权限" center :visible.sync="onSubmit" width="30%">
          <el-form ref="form" :model="form" label-width="15.0rem">
            <el-form-item label="权限列表">
              <el-select v-model="form.level_id" placeholder="选择权限" @change="jiantin">
                <el-option :value="item.id" v-for="(item, index) in daili" :key="index"
                  :label="item.priveName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="开通时长/年">
              <el-select :disabled="!message.basics" v-model="form.year" placeholder="选择年份" @change="jiantin">
                <el-option v-for="item in optionss" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="商城套餐">
              <el-select clearable :disabled="!message.basics" v-model="form.group_id" placeholder="选择套餐"
                @change="jiantin">
                <el-option v-for="(item, index) in shopList" :value="item.group_id" :key="index"
                  :label="item.group_name"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="!message.basics"></el-form-item>
            <div v-else>
              <span style="margin-left: 8.0rem; color: #298edb; margin-top: 2.0rem">说明信息</span>
              <el-form-item label="基础售价/年" style="margin-top: 2.0rem">
                <el-input clearable v-model="message.basics" :disabled="true"><i slot="suffix" class="dw">元</i></el-input>
              </el-form-item>
              <el-form-item v-if="form.group_id" label="商城基础售价/年" style="margin-top: 2.0rem">
                <el-input clearable v-model="message.fee" :disabled="true"><i slot="suffix" class="dw">元</i></el-input>
              </el-form-item>
              <el-form-item label="享受折扣">
                <el-input clearable v-model="message.discount" :disabled="true"><i slot="suffix"
                    class="dw">折</i></el-input>
              </el-form-item>
              <el-form-item label="折扣后价格/年">
                <el-input clearable v-model="message.discount_price" :disabled="true"><i slot="suffix"
                    class="dw">元</i></el-input>
              </el-form-item>
              <el-form-item label="crm使用人数">
                <el-input clearable v-model="message.crm_person" :disabled="true"><i slot="suffix"
                    class="dw">人</i></el-input>
              </el-form-item>
              <el-form-item label="会话存档使用人数">
                <el-input clearable v-model="message.session_person" :disabled="true"><i slot="suffix"
                    class="dw">人</i></el-input>
              </el-form-item>
              <el-form-item label="开通过期时间">
                <el-input clearable v-model="message.past_time" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item label="满">
                <el-input clearable v-model="message.buy" :disabled="true"><i slot="suffix" class="dw">年</i></el-input>
              </el-form-item>
              <el-form-item label="赠送">
                <el-input clearable v-model="message.give" :disabled="true"><i slot="suffix" class="dw">年</i></el-input>
              </el-form-item>
              <el-form-item label="总优惠">
                <el-input clearable v-model="message.total_price" :disabled="true"><i slot="suffix"
                    class="dw">元</i></el-input>
              </el-form-item>
              <el-form-item label="应支付">
                <el-input clearable v-model="message.total" :disabled="true"><i slot="suffix" class="dw">元</i></el-input>
              </el-form-item>
            </div>
            <el-form-item>
              <!-- 基础售价：{{ message.basics }}元；crm使用人数：{{
                message.crm_person
              }}人； <br />
              会话存档使用人数：{{ message.session_person }}人；享受折扣：{{
                message.discount
              }}折；<br />
              折扣后价格： {{ message.discount_price }}元；扣款总价：<span style="color:red;">{{message.total_price}} </span> 元；<br />
              开通过期时间：{{ message.past_time }}；<br />
              满： <span style="color:red">{{ message.buy }}</span> 年以上；赠送： <span style="color:red;">{{message.give}}</span> 年；<br /> -->
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="onSubmit = false">取 消</el-button>
            <el-button type="primary" @click="numoo()">确 定</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import Vue from "vue";
export default {
  data() {
    return {
      userSearch: '',//用户筛选的数据
      shopList: [],//商城套餐数据
      tableData: {
        total: 0,
        data: [],
      },
      url: "https://api.weijub.com/",
      yonghu: "",
      xinxi: [], //用户信息
      onSubmit: false,
      daili: [],
      form: {
        level_id: "", //从代理商等级管理获取，
        id: "",
        year: "1",
        group_id: ''
      },
      optionss: [
        {
          value: "1",
          label: "一年",
        },
        {
          value: "2",
          label: "二年",
        },
        {
          value: "3",
          label: "三年",
        },
        {
          value: "4",
          label: "四年",
        },
        {
          value: "5",
          label: "五年",
        },
        {
          value: "6",
          label: "六年",
        },
        {
          value: "7",
          label: "七年",
        },
        {
          value: "8",
          label: "八年",
        },
        {
          value: "9",
          label: "九年",
        },
        {
          value: "10",
          label: "十年",
        },
      ],
      message: {
        basic: ''
      },
      dengji: [],
      dengjilieb: "",
      username: "",
      title: {},
      listQuery: {
        page: 1,
        limit: 20,
      },
    };
  },
  mounted() {
    // if (window.sessionStorage.getItem("title")) {
    //   let title = JSON.parse(window.sessionStorage.getItem("title"));
    //   this.title = title;
    //   var a = document.title;
    //   document.title = title[0].website + "-" + a;
    // }
    //  获取代理商列表
    if (window.sessionStorage.getItem("userinfo")) {
      let userinfo = JSON.parse(window.sessionStorage.getItem("userinfo"));
      this.username = userinfo;
    }
    this.headlgetAgentAccounts();
    this.headlgetLevelList();
    this.headlgetShopList()
  },
  methods: {
    //获取商城套餐列表
    headlgetShopList() {
      this.axios
        .post(
          "/api/Prive/getGroupList",
          qs.stringify({
            agenttoken: this.username.agenttoken,
          }),
          {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
          }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/mine");
          }
          this.shopList = res.data.data
        })
        .catch(function (err) {
        });
    },
    jiantin() {
      this.axios
        .post(
          "/api/Index/getPeople",
          qs.stringify({
            user_account_id: this.form.id,
            prive_id: this.form.level_id,
            agenttoken: this.username.agenttoken,
            agent_id: this.username.id,
            year: this.form.year,
            group_id: this.form.group_id
          }),
          {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
          }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/mine");
          }
          this.message = res.data.data;
        })
        .catch(function (err) { });
    },
    skip(e) {
      // console.log(e);
      this.axios
        .post(
          "/api/user/userLogin",
          qs.stringify({
            phone: e.phone,
            password: e.password,
            account_id: e.id,
          }),
          {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
          }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            var storuser = res.data.data;
            // console.log(storuser);
            localStroage.setItem("storuser", JSON.stringify(storuser));
            let localStroage = window.localStorage;
            localStroage.setItem("usertoken", res.data.data.usertoken);
            localStroage.setItem("id", res.data.data.id);
            localStroage.setItem("phone", res.data.data.phone);
            localStroage.setItem("returnUrl", res.data.data.returnUrl);
            localStroage.setItem("account_id", res.data.data.account_id);
            // location.href = "https://work.weijub.com/#/register/user/dataTotal";
            if (res.data.data.role_id === 0) {
              this.getParams(
                res.data.data.id,
                res.data.data.usertoken,
                res.data.data.phone
              );
            } else if (res.data.data.role_id !== 0) {
              // this.$router.replace("register/user/dataTotal");
              const { href } = this.$router.resolve({
                path: "/register/user/dataTotal",
              });
              window.open(href, "_blank");
            }
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(function (err) { });
    },
    getParams(id, token, phone) {
      this.axios({
        method: "post",
        url: `/home/AccountInfo/getAccountInfo`,
        data: qs.stringify({
          account_id: id,
          usertoken: token,
          phone,
        }),
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      })
        .then((res) => {
          window.localStorage.setItem("account_id", id);
          window.localStorage.setItem("phone", phone);
          if (res.data.code === 0) {
            this.$router.push({
              name: "authorization",
            });
            console.log(res.data.code);
          } else if (res.data.code === 1) {
            // this.$router.push("/register/user/dataTotal");
            const { href } = this.$router.resolve({
              path: "/register/user/dataTotal",
            });
            window.open(href, "_blank");
          }
        })
        .catch((err) => { });
    },
    //   代理商等级
    headlgetLevelList() {
      this.axios
        .post(
          "/api/Prive/getPriveList",
          qs.stringify({
            agenttoken: this.username.agenttoken,
          }),
          {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
          }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/mine");
          }
          this.daili = res.data.data;
        })
        .catch(function (err) { });
    },
    numoo() {
      this.axios
        .post(
          "/api/index/accountPrive",
          qs.stringify({
            user_account_id: this.form.id,
            prive_id: this.form.level_id, //从代理商等级管理获取
            agenttoken: this.username.agenttoken,
            agent_id: this.username.id,
            year: this.form.year,
            group_id: this.form.group_id
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.onSubmit = false;
            this.headlgetAgentAccounts()
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else if (res.data.code == 0) {
            this.onSubmit = true;
            this.$message.error(res.data.msg);
          }
          if (res.data.msg == "登录超时") {
            this.$router.push("/mine");
          }
          this.her();
          this.headlgetAgentAccounts();
          this.daili = [];
          this.headlgetLevelList();
        })
        .catch(function (err) { });
    },
    headlgetAgentAccounts() {
      this.axios
        .post(
          "/api/agent/agentAccountPrive",
          qs.stringify({
            agent_id: this.username.id,
            agenttoken: this.username.agenttoken,
            page: this.listQuery.page,
            number_page: this.listQuery.limit,
            content: this.userSearch
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/mine");
          }
          this.tableData.total = res.data.count;
          this.tableData.data = res.data.data;
          this.dengji = res.data.data.priveName;
        })
        .catch(function (err) { });
    },
    fp(e, l) {
      this.dengjilieb = l;
      this.yonghu = e;
      this.form.id = e;
      this.axios
        .post(
          "/api/agent/agentAccountPrive",
          qs.stringify({
            agent_id: this.yonghu,
            agenttoken: this.username.agenttoken,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/mine");
          }
          this.xinxi = res.data.data;
        })
        .catch(function (err) { });
    },
  },
};
</script>
<style lang="scss" scoped>
.home {
  padding: 2rem;
  border-radius: .8rem;
  box-shadow: .3rem .3rem 2rem 0 rgba(0, 0, 0, 0.1);
}

::v-deep .el-table thead {
  color: #ffffff;
}

.body_html {
  width: 100%;
  height: 100%;
}

.wei_body {
  margin-top: 2.0rem;
  width: 100%;
  height: 90%;
  background-color: #ffffff;
  box-shadow: .0rem 1px 6px .0rem rgba(0, 0, 0, 0.2);
  padding: 1.0rem 31px;
  overflow: hidden;
  overflow-y: auto;
}

.tianjia {
  width: 100%;
  height: 100%;
}

.tianjia>main {
  font-size: 26px;
}

.bule {
  width: 100%;
  height: 69px;
  background-color: #2890dd;
  z-index: 10;
  position: absolute;
  top: .0rem;
  left: .0rem;
}

.danger {
  color: #f56c6c;
}

.nar {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 2.0rem;
}
</style>
